import type { OmuiCurrencyAmountInputComponent } from '../../../CurrencyAmountInput'

export const OmuiCurrencyAmountInput: OmuiCurrencyAmountInputComponent = {
  styleOverrides: {
    root: ({ theme }) => ({
      '& .MuiOutlinedInput-root': {
        borderRadius: 10,
        height: 36,
        paddingRight: '10px',
      },
      '& .MuiInputBase-input': {
        padding: '0 0 0 12px',
      },
      '& .MuiOutlinedInput-notchedOutline': {
        borderColor: theme.palette.divider,
      },
    }),
  },
}
